var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import './Grid.css';
export function Grid(_a) {
    var children = _a.children, _b = _a.container, container = _b === void 0 ? false : _b, _c = _a.item, item = _c === void 0 ? false : _c, _d = _a.spacing, spacing = _d === void 0 ? 0 : _d, _e = _a.direction, direction = _e === void 0 ? 'row' : _e, _f = _a.justifyContent, justifyContent = _f === void 0 ? 'flex-start' : _f, _g = _a.alignItems, alignItems = _g === void 0 ? 'stretch' : _g, _h = _a.alignContent, alignContent = _h === void 0 ? 'stretch' : _h, _j = _a.wrap, wrap = _j === void 0 ? 'wrap' : _j, _k = _a.zeroMinWidth, zeroMinWidth = _k === void 0 ? false : _k, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, _l = _a.className, className = _l === void 0 ? '' : _l, _m = _a.style, style = _m === void 0 ? {} : _m, other = __rest(_a, ["children", "container", "item", "spacing", "direction", "justifyContent", "alignItems", "alignContent", "wrap", "zeroMinWidth", "xs", "sm", "md", "lg", "xl", "className", "style"]);
    var getBreakpointClass = function (breakpoint, size) {
        if (size === true)
            return "grid-".concat(breakpoint);
        if (size === 'auto')
            return "grid-".concat(breakpoint, "-auto");
        // Handle string values (e.g., "6", "12", etc.)
        if (typeof size === 'string') {
            // Check if it's a valid grid number as string
            var numValue = parseInt(size, 10);
            if (!Number.isNaN(numValue) && numValue >= 1 && numValue <= 12) {
                return "grid-".concat(breakpoint, "-").concat(numValue);
            }
            // For other string values, use them directly
            return "grid-".concat(breakpoint, "-").concat(size);
        }
        return "grid-".concat(breakpoint, "-").concat(size);
    };
    var classes = [
        'grid-root',
        container && 'grid-container',
        item && 'grid-item',
        container && spacing > 0 && "grid-spacing-xs-".concat(spacing),
        container && direction !== 'row' && "grid-direction-xs-".concat(direction),
        container && justifyContent !== 'flex-start' && "grid-justify-xs-".concat(justifyContent),
        container && alignItems !== 'stretch' && "grid-align-items-xs-".concat(alignItems),
        container && alignContent !== 'stretch' && "grid-align-content-xs-".concat(alignContent),
        container && wrap !== 'wrap' && "grid-wrap-xs-".concat(wrap),
        item && zeroMinWidth && 'grid-zero-min-width',
        item && xs && getBreakpointClass('xs', xs),
        item && sm && getBreakpointClass('sm', sm),
        item && md && getBreakpointClass('md', md),
        item && lg && getBreakpointClass('lg', lg),
        item && xl && getBreakpointClass('xl', xl),
        className,
    ].filter(Boolean).join(' ');
    return (React.createElement("div", __assign({ className: classes, style: style }, other), children));
}
//# sourceMappingURL=Grid.js.map